import { useEffect, useState } from "react";
import { useGetVideosQuery } from "../../../features/Videos/videosApi";
import Video from "./components/Video";
import VideoDetails from "./components/VideoDetails";
import VideoListItem from "./components/VideoListItem";

export default function Player() {
  const { data: videos, isSuccess, isLoading, isError } = useGetVideosQuery();
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    if (videos?.length > 0) {
      setSelectedVideo(videos[0]);
    }
  }, [isSuccess]);

  return (
    <>
      <div className="col-span-full w-full space-y-8 lg:col-span-2">
        {!isLoading && !selectedVideo && <h1>No video to show</h1>}
        {!isLoading && selectedVideo && (
          <>
            <Video video={selectedVideo} />
            <VideoDetails video={selectedVideo} />
          </>
        )}
      </div>
      <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
        {isLoading && <p className="text-center">Loading videos...</p>}
        {isError && (
          <p className="text-center" colSpan="100%">
            Failed to fetch videos!
          </p>
        )}
        {!isLoading && videos.length === 0 && (
          <p className="text-center" colSpan="100%">
            No videos found!
          </p>
        )}

        {videos?.map((video) => (
          <VideoListItem
            video={video}
            key={video.id}
            setSelectedVideo={setSelectedVideo}
          />
        ))}
      </div>
    </>
  );
}
